import Model, { attr } from '@ember-data/model';

export default class TaskResultModel extends Model {
  @attr('string') declare label: string;
}

export let attemptedTaskResultId = '2';
